import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

class OfflineMethod extends React.PureComponent {
    static propTypes = {
        payment_method: PropTypes.string,
        method: PropTypes.string,
        onClick: PropTypes.func.isRequired,
    };

    isMethodActive = () => {
        return this.props.payment_method === 'offline';
    };

    onMethodClick = () => {
        if (this.isMethodActive()) {
            return;
        }
        this.props.onClick();
    };

    onMethodKeyDown = e => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.onMethodClick();
        }
    };

    render() {
        return (
            <div
                data-method="offline"
                className="m2g-order-confirmation-payment-method"
                data-checked={this.isMethodActive()}
                onClick={this.onMethodClick}
            >
                <span className="m2g-order-confirmation-payment-method-text">
                    <input
                        type="checkbox"
                        data-method="offline"
                        className="m2g-order-confirmation-payment-method-checkbox"
                        checked={this.isMethodActive()}
                        onChange={this.onMethodClick}
                        onKeyDown={this.onMethodKeyDown}
                    />
                    <Trans
                        i18nKey={`order.confirmation:pay_on_${this.props.method}`}
                    >
                        I will pay&nbsp;<strong>on method</strong>
                    </Trans>
                </span>
            </div>
        );
    }
}

export default OfflineMethod;
